// extracted by mini-css-extract-plugin
export var address = "footer-module--address--9cbb4";
export var addressBlock = "footer-module--addressBlock--297f7";
export var addressBlockWrap = "footer-module--addressBlockWrap--3b496";
export var alignImageRight = "footer-module--alignImageRight--02ba0";
export var behance = "footer-module--behance--67545";
export var container = "footer-module--container--6b3aa";
export var copyText = "footer-module--copyText--dddd9";
export var dribble = "footer-module--dribble--ac676";
export var facebook = "footer-module--facebook--0d23d";
export var flagBlock = "footer-module--flagBlock--9e8c3";
export var footerBottom = "footer-module--footerBottom--d58fa";
export var footerBottomleft = "footer-module--footerBottomleft--a4031";
export var footerBottomright = "footer-module--footerBottomright--0f7ca";
export var footerContent = "footer-module--footerContent--e005a";
export var footerContentRight = "footer-module--footerContentRight--20ea7";
export var footerContentWrap = "footer-module--footerContentWrap--fa9c8";
export var footerContent_Logo = "footer-module--footerContent_Logo--c0d65";
export var footerLogoBottom = "footer-module--footerLogoBottom--467ed";
export var footerMenu = "footer-module--footerMenu--52a30";
export var footerMenuWrap = "footer-module--footerMenuWrap--c0ae5";
export var footerWrap = "footer-module--footerWrap--b5978";
export var hoverImage = "footer-module--hoverImage--0dde1";
export var iconBg = "footer-module--iconBg--e07f2";
export var iconBox = "footer-module--iconBox--d7269";
export var iconImage = "footer-module--iconImage--59d72";
export var iconWrap = "footer-module--iconWrap--60244";
export var instagram = "footer-module--instagram--2607e";
export var linkedIn = "footer-module--linkedIn--5c194";
export var mail = "footer-module--mail--1341d";
export var para_footer = "footer-module--para_footer--287e6";
export var socialIcons = "footer-module--socialIcons--b1645";
export var twitter = "footer-module--twitter--41d80";